import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import WizardContent from 'components/organisms/WizardContent/WizardContent/WizardContent';

const StyledChooseSaveWizardContent = styled(WizardContent)`
  ${ComponentStyles}
`;

StyledChooseSaveWizardContent.propTypes = {
  theme: PropTypes.object
};

export default StyledChooseSaveWizardContent;
